import { FAQS } from "@/data/clinic";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";

export default function FAQsPage() {
  return (
    <div data-testid="faqs-page">
      <SEOHead
        title="FAQs | Dr. Ashutosh Mishra — Diabetologist & Endocrinologist Varanasi"
        description="Frequently asked questions about diabetes, thyroid, PCOS, obesity and endocrine care at Dr. Ashutosh Mishra's clinic in Varanasi."
        path="/faqs"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "FAQs", url: "/faqs" },
        ]}
        faqs={FAQS}
      />
      <section className="bg-gradient-to-br from-green-50/60 via-white to-green-50/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <nav className="text-xs text-slate-500 mb-3 text-left">
            <Link to="/" className="hover:text-green-700">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">FAQs</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.22em] text-green-700 font-medium">Help center</div>
          <h1 className="font-poppins font-semibold text-4xl sm:text-5xl lg:text-6xl text-slate-900 mt-3">Frequently Asked Questions</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Accordion type="single" collapsible>
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-slate-200" data-testid={`faqs-item-${i}`}>
              <AccordionTrigger className="text-left font-medium text-slate-900 hover:text-green-700 py-5 text-base">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
